module.exports = "/_next/static/images/logo-3-84c754bf45bd753918a95c6bc1257639.svg";